// import useMarketo from 'hooks/useMarketo';

import { useRef, useState } from 'react';
import api from 'services/api';
import { StarIcon } from 'components/icons/StarIcon';
import SubmissionImg from 'assets/img/submission.webp';
import SlidoPollForm from 'components/PollOptions/SlidoPollForm';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';

interface IFeedback {
  videoId?: string;
  viewer: any;
  setIsFeedbackSubmitted: any;
  pollsData: any[];
  setCurrentPoll: any;
  currentPoll: any;
  topSectionHeight?: number;
}

function Feedback({
  videoId,
  viewer,
  setIsFeedbackSubmitted,
  pollsData,
  currentPoll,
  setCurrentPoll,
  topSectionHeight
}: IFeedback) {
  const [success, onSuccess] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState(0);
  const wrapperRef = useRef<HTMLSpanElement>();

  const handleRatingChange = (newRating: number) => {
    setRating(newRating);
  };

  const handleInputChange = (e: any) => {
    setFeedback(e.target.value);
  };

  const handleSubmit = () => {
    api
      .post(`api/videos/${videoId}/external-feedback/`, {
        feedback: [{ feedback: 'Please share any feedback', answer: feedback }],
        rating,
        viewer
      })
      .then(() => {
        onSuccess(true);
        setIsFeedbackSubmitted(true);
      });
  };

  return (
    <div className="mr-3 rounded-md text-black text-sm w-full overflow-y-auto h-full">
      <PerfectScrollbar
        style={{ maxHeight: topSectionHeight ? `calc(100vh - ${topSectionHeight + 100}px)` : `calc(100vh - 120px)` }}
        options={{ suppressScrollY: false, suppressScrollX: true }}
        containerRef={(el) => (wrapperRef.current = el)}
      >
        {pollsData.length ? (
          <SlidoPollForm
            pollsData={pollsData}
            setCurrentPoll={setCurrentPoll}
            currentPoll={currentPoll}
            videoId={videoId}
            viewer={viewer}
            wrapperRef={wrapperRef}
          />
        ) : (
          <div className="p-4">
            {success ? (
              <>
                <div className="h-80 overflow-hidden">
                  <img src={SubmissionImg} alt="webp" />
                </div>
                <p className="mt-5 text-lg font-semibold text-center">Thank you, {viewer?.firstname}!</p>
              </>
            ) : (
              <>
                <p className="font-semibold">Your feedback is valuable. Please evaluate today&apos;s presentation.</p>
                <div className="my-3">
                  <span>1 - Poor</span>
                  <span className="ml-4">5 - Excellent</span>
                </div>
                <div className="flex my-5">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <StarIcon
                      key={star}
                      onClick={() => handleRatingChange(star)}
                      className={`${star <= rating ? 'fill-red-main' : ''} w-5 h-5 mr-2 cursor-pointer`}
                      fill={star <= rating ? 'red' : ''}
                    />
                  ))}
                </div>
                <fieldset className="mt-2">
                  <label className="block font-semibold mb-2" htmlFor="feedback">
                    Please share any feedback(optional)
                  </label>
                  <textarea
                    className="border border-gray-300 rounded-md px-3 py-2 w-full mb-3"
                    id="feedback"
                    name="feedback"
                    spellCheck="false"
                    onChange={handleInputChange}
                  ></textarea>
                </fieldset>
                <button
                  className="bg-red-main hover:bg-red-main text-white font-bold py-3 px-12 rounded focus:outline-none focus:shadow-outline"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </>
            )}
          </div>
        )}
      </PerfectScrollbar>
    </div>
  );
}

export default Feedback;
